import axios from "axios";
import { serviceBaseUrl } from "./constants";

export const fetchAllUsers = async () => {
  try {
    const response = await axios.get(`${serviceBaseUrl}/users`, {
      withCredentials: true,
    });
    console.log(response.data)
    return response.data?.result;
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
};

export const getUserById = async (userId: string) => {
  try {
    const response = await axios.get(`${serviceBaseUrl}/${userId}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching user with ID ${userId}:`, error);
    throw error;
  }
};

export const updateUser = async (userData: any) => {
  try {
    const response = await axios.post(
      `${serviceBaseUrl}/updateUser`,
      userData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(`Error updating user:`, error);
    throw error;
  }
};


